export default "__VITE_ASSET__CwSDEr4e__"